import { types } from 'mobx-state-tree';
import FilterOptionModel from './FilterOptionModel';

const RadioFilterModel = types
    .model('RadioFilter', {
        name: types.string,
        title: types.string,
        options: types.array(FilterOptionModel),
        value: types.string,
        type: types.literal('Radio'),
        defaultValue: types.maybe(types.string),
    })
    .views(self => ({
        get selectedOptions() {
            if (self.value === self.defaultValue) return [];
            return self.options.filter(option => self.value === option.value);
        },

        get valueForQuery() {
            if (self.value.length) {
                return self.value === self.defaultValue ? null : self.value;
            }
            return null;
        },

        isMatch(value = '') {
            if (!value.length) {
                if (!self.value.length) {
                    return true;
                }

                if (self.value === self.defaultValue) {
                    return true;
                }
            }

            if (self.value.length) {
                return value === self.value;
            }

            return value === self.defaultValue;
        },
    }))
    .actions(self => ({
        setValue(value = '') {
            self.value = value;
        },

        clear() {
            self.value = '';
        },

        reset() {
            self.value = '';
        },
    }));

export default RadioFilterModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/RadioFilterModel.js